'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _organizingCommittees = require('../actions/organizingCommittees');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchOrganizingCommittees),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchOrganizingCommittee),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editOrganizingCommittee),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createOrganizingCommitte),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchOrganizingCommitteesRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchOrganizingCommitteeRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editOrganizingCommitteeRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createOrganizingCommitteeRequest);

function fetchOrganizingCommittees() {
    var response;
    return regeneratorRuntime.wrap(function fetchOrganizingCommittees$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/organizingcommittees');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.fetchOrganizingCommitteesSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.fetchOrganizingCommitteesFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchOrganizingCommittee(_ref) {
    var organizingCommitteeId = _ref.organizingCommitteeId;
    var response;
    return regeneratorRuntime.wrap(function fetchOrganizingCommittee$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/organizingcommittees/' + organizingCommitteeId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.fetchOrganizingCommitteeSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.fetchOrganizingCommitteeFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editOrganizingCommittee(_ref2) {
    var organizingCommitteeId = _ref2.organizingCommitteeId,
        changes = _ref2.changes,
        redirect = _ref2.redirect;
    return regeneratorRuntime.wrap(function editOrganizingCommittee$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/organizingcommittees/' + organizingCommitteeId, changes);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.editOrganizingCommitteeSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.editOrganizingCommitteeFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function createOrganizingCommitte(_ref3) {
    var organizingCommittee = _ref3.organizingCommittee,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function createOrganizingCommitte$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/organizingcommittees/', organizingCommittee);

                case 3:
                    _context4.next = 5;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.createOrganizingCommitteeSucceeded());

                case 5:
                    if (!redirect) {
                        _context4.next = 8;
                        break;
                    }

                    _context4.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 14;
                    return (0, _effects.put)(_organizingCommittees.actionCreators.createOrganizingCommitteeFailed());

                case 14:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 10]]);
}

function fetchOrganizingCommitteesRequest() {
    return regeneratorRuntime.wrap(function fetchOrganizingCommitteesRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_organizingCommittees.actionTypes.FETCH_ORGANIZING_COMMITTEES_REQUEST, fetchOrganizingCommittees);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function fetchOrganizingCommitteeRequest() {
    return regeneratorRuntime.wrap(function fetchOrganizingCommitteeRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_organizingCommittees.actionTypes.FETCH_ORGANIZING_COMMITTEE_REQUEST, fetchOrganizingCommittee);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editOrganizingCommitteeRequest() {
    return regeneratorRuntime.wrap(function editOrganizingCommitteeRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_organizingCommittees.actionTypes.EDIT_ORGANIZING_COMMITTEE_REQUEST, editOrganizingCommittee);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createOrganizingCommitteeRequest() {
    return regeneratorRuntime.wrap(function createOrganizingCommitteeRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_organizingCommittees.actionTypes.CREATE_ORGANIZING_COMMITTEE_REQUEST, createOrganizingCommitte);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchOrganizingCommitteesRequest, fetchOrganizingCommitteeRequest, editOrganizingCommitteeRequest, createOrganizingCommitteeRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/organizingCommittees.js
// module id = 2240
// module chunks = 0